"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DryDeserts = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const RemoveOceanTile_1 = require("../../deferredActions/RemoveOceanTile");
const SelectResourcesDeferred_1 = require("../../deferredActions/SelectResourcesDeferred");
class DryDeserts {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.DRY_DESERTS;
        this.description = 'First player removes 1 ocean tile from the gameboard. Gain 1 standard resource per influence.';
        this.revealedDelegate = PartyName_1.PartyName.REDS;
        this.currentDelegate = PartyName_1.PartyName.UNITY;
    }
    resolve(game, turmoil) {
        const canRemoveOcean = game.canRemoveOcean();
        if (canRemoveOcean) {
            game.defer(new RemoveOceanTile_1.RemoveOceanTile(game.getPlayersStillInGame()[0], 'Dry Deserts Global Event - Remove an Ocean tile from the board'));
        }
        game.getPlayers().forEach((player) => {
            const count = turmoil.getPlayerInfluence(player);
            if (count > 0 && !player.hasConceded) {
                game.defer(new SelectResourcesDeferred_1.SelectResourcesDeferred(player, count, 'Dry Deserts Global Event - Gain ' + count + ' resource(s) for influence'));
            }
        });
    }
}
exports.DryDeserts = DryDeserts;
//# sourceMappingURL=DryDeserts.js.map